<template>
  <div>
    <v-overlay v-show="loader">Cargando </v-overlay>
    <v-card elevation="2">
      <v-card-title class="mt-8">
        {{ dataEdit.Nombre }}
      </v-card-title>
      <v-card-text
        v-for="(existencia, index) in dataEdit.existenciaPrecio"
        :key="index"
      >
        <v-text-field
          v-model="existencia.Price.PV"
          :label="existencia.NombreOrigen"
        ></v-text-field>
      </v-card-text>
      <v-card-text>
        <div class="text-right">
          <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
          <v-btn
            style="margin-left: 6px"
            color="success"
            large
            @click="savePrecios()"
            >Guardar</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
export default {
  name: "ProductoPrecioForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      loader: true,
      Id: "",
    };
  },
  methods: {
    savePrecios() {
      let updates = [];
      this.dataEdit.existenciaPrecio.forEach((update) => {
        updates.push({
          Origen: update.Origen,
          Precio: Number(update.Price.PV),
        });
      });
      let data = {
        Producto: this.dataEdit.id,
        Updates: updates,
      };
      this.$swal({
        title: "¿Deseas editar el precio de este producto?",
        text: "Los cambios se veran reflejados inmediatamente",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar Precio",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //'ProShop-Productos-editarProducto'
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-updatePrecioProducto", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El precio de producto se edito correctamente",
              icon: "success",
            }).then(() => {
              this.$emit("toggle", false);
            });
          } else {
            this.$swal(
              "Error guardando Precios",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
  },
  computed: {},
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.loader = false;
  },
};
</script>
